<div class="default-row mt-0 mb-3 background-form">
  @if (config?.fromPackOff) {
    <div class="row-item-button">
      <div style="width: 100%">
        @if (comboConfigWarehouseByItem?.selected !== undefined) {
          <combos
            [configuration]="comboConfigWarehouseByItem"
            [reloadCombo]="reloadComboWarehouseByItem"
            [required]="true"
            [filter]="true"
            [dataCombos]="config.comboDataWarehouse"
            (changeOptionDataComplete)="valueWarehouseByItem($event)"
            >
          </combos>
        }
      </div>
    </div>
  }
  <div class="row-item-button">
    <div style="width: 100%">
      @if (comboConfigItem) {
        <combos
          [configuration]="comboConfigItem"
          [reloadCombo]="reloadComboItem"
          [required]="true"
          [filter]="true"
          [dataCombos]="
            element.warehouseId
              ? config.comboItemsByWarehouse[element.warehouseId] ?? []
              : config.comboDataItems
          "
          (changeOption)="valueIDItem($event)"
          [disabled]="!config.view || config.addRentalOrder"
          >
        </combos>
      }
    </div>
    @if (config?.addNewItem && config?.view) {
      <div
        style="min-width: 24px; max-width: 24px; cursor: pointer"
        >
        <div (click)="addNew('item')" matRipple>
          <mat-icon>add_circle</mat-icon>
        </div>
      </div>
    }
  </div>
  @if (config?.showAmount) {
    <div class="row-item">
      <mat-form-field>
        <mat-label>Cantidad</mat-label>
        <input
          type="number"
          [disabled]="!element.itemInventoryId || !config.view"
          (keyup)="keyUpAmout()"
          autocomplete="off"
          step="any"
          min="1"
          matInput
          #cantidad
          required
          [(ngModel)]="element.amount"
          oninput="this.value = this.value.slice(0,30)"
          placeholder="Cantidad"
          />
        <mat-error>Campo requerido</mat-error>
        <mat-hint>{{ cantidad.value.length }}/30</mat-hint>
      </mat-form-field>
    </div>
  }
  @if (config?.isMobile && config?.showCurrentAmount) {
    <div class="row-item">
      <mat-form-field>
        <mat-label>Cantidad Inventario</mat-label>
        <input
          autocomplete="off"
          type="text"
          matInput
          #cantidadActual
          [(ngModel)]="element.currentAmount"
          disabled
          [readonly]="true"
          oninput="this.value = this.value.slice(0,8)"
          placeholder="Cantidad Inventario"
          />
      </mat-form-field>
    </div>
  }
  @if (config?.isMobile) {
    <div class="row-item">
      <mat-form-field>
        <mat-label>Costo Unidad</mat-label>
        <input
          autocomplete="off"
          type="text"
          appThousandSeparator
          matInput
          #constItem
          (keyup)="keyUpAmout()"
          [(ngModel)]="element.costItem"
          [readonly]="false"
          [disabled]="!config.editCostItem || !config.view"
          oninput="this.value = this.value.slice(0,30)"
          placeholder="Costo Unidad"
          />
        <mat-hint>{{ constItem.value.length }}/30</mat-hint>
      </mat-form-field>
    </div>
  }
  @if (config?.isMobile && !config?.fromPackOff) {
    <div class="row-item">
      <mat-form-field>
        <mat-label>{{ config.labelCodigo }}</mat-label>
        <input
          autocomplete="off"
          type="text"
          matInput
          #codigo
          [(ngModel)]="element.code"
          disabled
          [readonly]="true"
          oninput="this.value = this.value.slice(0,30)"
          [placeholder]="config.labelCodigo"
          />
      </mat-form-field>
    </div>
  }
  @if (config?.isMobile && config?.showUnitMeasurement) {
    <div class="row-item">
      <mat-form-field>
        <mat-label>Unidad</mat-label>
        <input
          autocomplete="off"
          type="text"
          matInput
          #unidad
          [(ngModel)]="element.unitMeasurement"
          disabled
          [readonly]="true"
          oninput="this.value = this.value.slice(0,30)"
          placeholder="Unidad"
          />
      </mat-form-field>
    </div>
  }
  @if (config?.itemsDataLength > 1 && config?.view && config?.showDeleteItem) {
    <button
      class="mr-1"
      mat-icon-button
      color="primary"
      (click)="deleteItemsData()"
      >
      <mat-icon>close</mat-icon>
    </button>
  }
</div>
